import { AccModeEnum } from './acc-mode.enum';
import { isUnifiedProjectType, ProjectSubType, ProjectType } from './project-type.enum';
import { SystemTypes } from './system-types.enum';
import { AngularMode } from './angular-mode.enum';
import { AppPermissions } from './app-permissions';
import { RdxDevTerminologyType } from './teminology-type.enum';

export class ProjectInfo implements ProjectInfoRaw {
    hasPermissionToDelete: boolean;
    hasPermissionToMassEdit: boolean;
    hasPermissionToLinkRequirement: boolean;
    accountOnTrial: boolean;
    hasSatellite: boolean;
    hasDevModuleIssues: boolean;
    hasTests: boolean;
    hasCodeCorrections: boolean;
    hasRequirements: boolean;
    quickTestSupported: boolean;
    tamperedJavaCheck: boolean;
    devTerminology: RdxDevTerminologyType;
    iterationTerminology: number;
    entityType2StandardFields: {
        [key: string]: { technicalName: string; visibleName: string; headerFieldTranslateKey: string; renamed: boolean }[];
    };

    support: any;
    hasUploadTestPermission: boolean;
    hasUploadPTLPermission: boolean;
    permissions: AppPermissions;
    companyId: number;
    cbtEnabled: boolean;
    projectName: string;
    projectGuid: string;
    newProject: boolean;
    projectType: number;
    projectTypeString: string;
    hasActiveEtl: boolean;
    hasValidEtl: boolean;
    projectInProgress: boolean;
    hasPtl: boolean;
    projectSubType: number;
    hanaMode: number;
    hasHrTarget: boolean;
    sapVersionSrcId: number;
    sapVersionTargetId: number;
    targetSpsName: string;
    etlExportedDate: string;
    sapVersionEnum: number;
    spStackBaseLevel: number;
    id: number;
    projectId: number;
    systemId: number;
    systemName: string;
    systemType: number;
    restrictedCycleEnabled: boolean;
    hasSFinTarget: boolean;
    allowCopyForOtherCompany: boolean;
    projectStatus: string;
    deleteTxnEnabled: boolean;
    customEntityTypes: { id: number; name: string; entityType: number; inUse: boolean }[];
    accountAbTesting: {
        shouldUseNewUi: number;
        useNewUi_Defects: number;
        useNewUi_Tests: number;
        useNewUi_Corrections: number;
        hideDetailsView: number;
        enableSalesforceApiTests: number;
        automated_test_conversion: number;
        file_to_automated_test_conversion: number;
        text_to_automated_test?: number;
        direct_automated_test_conversion: number;
        entity_list_ai_search?: number;
        import_from_worksoft: number;
        Locota_enableResolver?: number;
        Locota_convertSrToScript?: number;
        Locota_cleverCompare?: number;
    };
    modules: string[];
    hrOnly: boolean;
    accMode: AccModeEnum;
    restrictedCycleNames: [];
    oracle: boolean;
    etlProcessing: boolean;
    testAutomation: boolean;
    playerEnabled: boolean;
    restrictedApp: boolean;
    qcV1Enbld: boolean;
    testCatalog: boolean;
    iterationsEnabled: boolean;
    omega: boolean;
    connectedToOracleSystem: boolean;
    scm: boolean;
    ntm: boolean;
    rdxEnabled: boolean;
    panayaUser: boolean;
    qc: boolean;
    regulatedSystem: boolean;
    allowTestAuthorAsApprover: boolean;
    recorderEnabled: boolean;
    modular: boolean;
    orgOverviewVisible: boolean;
    topUsersUsageEnabled: boolean;
    toscaEnabled: boolean;
    iaEnabled: boolean;
    sfFreeTrial: boolean;
    s4BestPracticeEnabled: boolean;
    projectManager: boolean;
    riskAnalysisEnabled: boolean;
    angularMode: AngularMode;
    activeEtlId: number;
    accountOnDemo: boolean;
    locotaEnabled: boolean;
    checkoutEnabled: boolean;
    testAutomationStandalone: boolean;
    jiraIssueCollectorUrl?: string;
    isUsageDataLessThan1Year?: boolean;
    sapSystemId?: string;
    qtEnabled: boolean;
    useAggregatedPerformanceTasks: boolean;
    dummyUserId?: number;

    constructor(data: ProjectInfoRaw) {
        this.projectId = data.id;
        this.locotaEnabled = data.locotaEnabled;
        this.checkoutEnabled = data.checkoutEnabled;
        this.testAutomationStandalone = data.testAutomationStandalone;
        this.hasPermissionToDelete = data.hasPermissionToDelete;
        this.hasPermissionToMassEdit = data.hasPermissionToMassEdit;
        this.hasPermissionToLinkRequirement = data.hasPermissionToLinkRequirement;
        this.accountOnTrial = data.accountOnTrial;
        this.hasSatellite = data.hasSatellite;
        this.hasDevModuleIssues = data.hasDevModuleIssues;
        this.hasTests = data.hasTests;
        this.hasCodeCorrections = data.hasCodeCorrections;
        this.hasRequirements = data.hasRequirements;
        this.quickTestSupported = data.quickTestSupported;
        this.tamperedJavaCheck = data.tamperedJavaCheck;
        this.devTerminology = data.devTerminology;
        this.iterationTerminology = data.iterationTerminology;
        this.entityType2StandardFields = data.entityType2StandardFields;
        this.support = data.support;
        this.hasUploadTestPermission = data.hasUploadTestPermission;
        this.hasUploadPTLPermission = data.hasUploadPTLPermission;
        this.permissions = data.permissions;
        this.companyId = data.companyId;
        this.cbtEnabled = data.cbtEnabled;
        this.projectName = data.projectName;
        this.projectGuid = data.projectGuid;
        this.newProject = data.newProject;
        this.projectType = data.projectType;
        this.projectTypeString = data.projectTypeString;
        this.hasActiveEtl = data.hasActiveEtl;
        this.hasValidEtl = data.hasValidEtl;
        this.projectInProgress = data.projectInProgress;
        this.hasPtl = data.hasPtl;
        this.projectSubType = data.projectSubType;
        this.hanaMode = data.hanaMode;
        this.hasHrTarget = data.hasHrTarget;
        this.sapVersionSrcId = data.sapVersionSrcId;
        this.sapVersionTargetId = data.sapVersionTargetId;
        this.targetSpsName = data.targetSpsName;
        this.etlExportedDate = data.etlExportedDate;
        this.sapVersionEnum = data.sapVersionEnum;
        this.spStackBaseLevel = data.spStackBaseLevel;
        this.id = data.id;
        this.systemId = data.systemId;
        this.systemName = data.systemName;
        this.systemType = data.systemType;
        this.restrictedCycleEnabled = data.restrictedCycleEnabled;
        this.hasSFinTarget = data.hasSFinTarget;
        this.allowCopyForOtherCompany = data.allowCopyForOtherCompany;
        this.projectStatus = data.projectStatus;
        this.deleteTxnEnabled = data.deleteTxnEnabled;
        this.customEntityTypes = data.customEntityTypes;
        this.accountAbTesting = data.accountAbTesting;
        this.modules = data.modules || [];
        this.hrOnly = data.hrOnly;
        this.accMode = data.accMode;
        this.restrictedCycleNames = data.restrictedCycleNames;
        this.oracle = data.oracle;
        this.etlProcessing = data.etlProcessing;
        this.testAutomation = data.testAutomation;
        this.playerEnabled = data.playerEnabled;
        this.restrictedApp = data.restrictedApp;
        this.qcV1Enbld = data.qcV1Enbld;
        this.testCatalog = data.testCatalog;
        this.iterationsEnabled = data.iterationsEnabled;
        this.omega = data.omega;
        this.connectedToOracleSystem = data.connectedToOracleSystem;
        this.scm = data.scm;
        this.ntm = data.ntm;
        this.rdxEnabled = data.rdxEnabled;
        this.panayaUser = data.panayaUser;
        this.qc = data.qc;
        this.regulatedSystem = data.regulatedSystem;
        this.allowTestAuthorAsApprover = data.allowTestAuthorAsApprover;
        this.recorderEnabled = data.recorderEnabled;
        this.modular = data.modular;
        this.orgOverviewVisible = data.orgOverviewVisible;
        this.topUsersUsageEnabled = data.topUsersUsageEnabled;
        this.toscaEnabled = data.toscaEnabled;
        this.iaEnabled = data.iaEnabled;
        this.sfFreeTrial = data.sfFreeTrial;
        this.s4BestPracticeEnabled = data.s4BestPracticeEnabled;
        this.projectManager = data.projectManager;
        this.angularMode = data.angularMode;
        this.activeEtlId = data.activeEtlId;
        this.accountOnDemo = data.accountOnDemo;
        this.riskAnalysisEnabled = data.riskAnalysisEnabled;
        this.jiraIssueCollectorUrl = data.jiraIssueCollectorUrl;
        this.isUsageDataLessThan1Year = data.isUsageDataLessThan1Year;
        this.sapSystemId = data.sapSystemId;
        this.qtEnabled = data.qtEnabled;
        this.useAggregatedPerformanceTasks = data.useAggregatedPerformanceTasks;
        this.dummyUserId = data.dummyUserId;
    }

    isSalesforceProject(): boolean {
        return this.systemType === SystemTypes.SALESFORCE;
    }
    isS4ConversionProject(): boolean {
        return this.projectType === ProjectType.S4_CONVERT || this.projectType === ProjectType.S4_CONVERT_NEW;
    }
    isS4ConvertNew(): boolean {
        return this.projectType === ProjectType.S4_CONVERT_NEW;
    }
    isS4AccelerateNew(): boolean {
        return this.projectType === ProjectType.S4_ACCELERATE_NEW;
    }
    isSpsNew(): boolean {
        return this.projectType === ProjectType.SUPPORT_PACKAGE_NEW;
    }
    isUnifiedProject(): boolean {
        return isUnifiedProjectType(this.projectType);
    }
    isIcr3Project(): boolean {
        return this.projectType === ProjectType.ICR_3;
    }
    isCleanCoreProject(): boolean {
        return this.projectType === ProjectType.CLEAN_CORE;
    }
    isIncludesAccAnalysisProject(): boolean {
        return (
            this.projectType === ProjectType.ICR_3 ||
            this.projectType === ProjectType.S4_CONVERT_NEW ||
            this.projectType === ProjectType.S4_ACCELERATE_NEW ||
            this.projectType === ProjectType.SUPPORT_PACKAGE_NEW
        );
    }
    isS4AccelerateProject(): boolean {
        return this.projectType === ProjectType.S4_ACCELERATE || this.projectType === ProjectType.S4_ACCELERATE_NEW;
    }
    isS4GreenProject(): boolean {
        return this.projectType === ProjectType.S4_GREEN;
    }
    isSupportPackageProject(): boolean {
        return this.projectType === ProjectType.SUPPORT_PACKAGE || this.projectType === ProjectType.SUPPORT_PACKAGE_NEW;
    }
    isOracleUpgradeProject(): boolean {
        return this.projectType === ProjectType.ORACLE_UPGRADE;
    }
    isOraclePatchesProject(): boolean {
        return this.projectType === ProjectType.ORACLE_PATCHES;
    }
    isOracleOnlinePatchesProject(): boolean {
        return this.projectType === ProjectType.ORACLE_ONLINE_PATCHES;
    }
    isUpgradeProject(): boolean {
        return this.projectType === ProjectType.UPGRADE;
    }
    isCleansingProject(): boolean {
        return this.projectType === ProjectType.CLEANSING;
    }
    isS4Project(): boolean {
        return this.isS4ConversionProject() || this.isS4AccelerateProject() || this.isIcr3Project() || this.isS4ConvertNew();
    }
    isS4HanaProject(): boolean {
        return this.isS4PrepProject() || this.isS4ConversionProject() || this.isS4AccelerateProject() || this.isIcr3Project();
    }
    isS4PrepProject(): boolean {
        return (
            this.projectType === ProjectType.TESTING_ONLY &&
            (this.projectSubType === ProjectSubType.S4_PREP || this.projectSubType === ProjectSubType.S4_GREEN_BASIC)
        );
    }
    isTestingOnlyProject(): boolean {
        return this.projectType === ProjectType.TESTING_ONLY;
    }
    isVfStandaloneProject(): boolean {
        return this.projectType === ProjectType.STANDALONE_PROJECT;
    }
    isIAProject(): boolean {
        return (
            this.isSupportPackageProject() ||
            this.isCleansingProject() ||
            this.isS4ConversionProject() ||
            this.isIcr3Project() ||
            this.isS4AccelerateProject() ||
            this.isOraclePatchesProject() ||
            this.isUpgradeProject() ||
            this.isOracleUpgradeProject() ||
            this.isOracleOnlinePatchesProject()
        );
    }
    isSapIAProject(): boolean {
        return this.isSupportPackageProject() || this.isUpgradeProject() || this.isS4Project();
    }
    isRestrictedApp(): boolean {
        return !this.hasActiveEtl || (this.accountOnTrial && !this.panayaUser);
    }
    hasTestsModule(): boolean {
        return this.modules.includes('TESTS');
    }
    hasModule(module: string): boolean {
        return this.modules.includes(module);
    }
}

export interface ProjectInfoRaw {
    hasPermissionToDelete: boolean;
    hasPermissionToMassEdit: boolean;
    hasPermissionToLinkRequirement: boolean;
    accountOnTrial: boolean;
    hasSatellite: boolean;
    hasDevModuleIssues: boolean;
    hasTests: boolean;
    hasCodeCorrections: boolean;
    hasRequirements: boolean;
    quickTestSupported: boolean;
    tamperedJavaCheck: boolean;
    devTerminology: number;
    iterationTerminology: number;
    entityType2StandardFields: {
        [key: string]: { technicalName: string; visibleName: string; headerFieldTranslateKey: string; renamed: boolean }[];
    };

    support: any;
    hasUploadTestPermission: boolean;
    hasUploadPTLPermission: boolean;
    permissions: AppPermissions;
    companyId: number;
    cbtEnabled: boolean;
    projectName: string;
    projectGuid: string;
    newProject: boolean;
    projectType: number;
    projectTypeString: string;
    hasActiveEtl: boolean;
    hasValidEtl: boolean;
    projectInProgress: boolean;
    hasPtl: boolean;
    projectSubType: number;
    hanaMode: number;
    hasHrTarget: boolean;
    sapVersionSrcId: number;
    sapVersionTargetId: number;
    targetSpsName: string;
    etlExportedDate: string;
    sapVersionEnum: number;
    spStackBaseLevel: number;
    id: number;
    projectId: number;
    systemId: number;
    systemName: string;
    systemType: number;
    restrictedCycleEnabled: boolean;
    hasSFinTarget: boolean;
    allowCopyForOtherCompany: boolean;
    projectStatus: string;
    deleteTxnEnabled: boolean;
    customEntityTypes: { id: number; name: string; entityType: number; inUse: boolean }[];
    accountAbTesting: {
        shouldUseNewUi: number;
        useNewUi_Defects: number;
        useNewUi_Tests: number;
        useNewUi_Corrections: number;
        hideDetailsView: number;
        enableSalesforceApiTests: number;
        automated_test_conversion: number;
        file_to_automated_test_conversion: number;
        text_to_automated_test?: number;
        direct_automated_test_conversion: number;
        entity_list_ai_search?: number;
        import_from_worksoft: number;
        Locota_enableResolver?: number;
        Locota_convertSrToScript?: number;
        Locota_cleverCompare?: number;
    };
    modules: string[];
    hrOnly: boolean;
    accMode: AccModeEnum;
    restrictedCycleNames: [];
    oracle: boolean;
    etlProcessing: boolean;
    testAutomation: boolean;
    playerEnabled: boolean;
    restrictedApp: boolean;
    qcV1Enbld: boolean;
    testCatalog: boolean;
    iterationsEnabled: boolean;
    omega: boolean;
    connectedToOracleSystem: boolean;
    scm: boolean;
    ntm: boolean;
    rdxEnabled: boolean;
    panayaUser: boolean;
    qc: boolean;
    regulatedSystem: boolean;
    allowTestAuthorAsApprover: boolean;
    recorderEnabled: boolean;
    modular: boolean;
    orgOverviewVisible: boolean;
    topUsersUsageEnabled: boolean;
    toscaEnabled: boolean;
    riskAnalysisEnabled: boolean;
    iaEnabled: boolean;
    sfFreeTrial: boolean;
    s4BestPracticeEnabled: boolean;
    projectManager: boolean;
    angularMode: number;
    activeEtlId: number;
    accountOnDemo: boolean;
    locotaEnabled: boolean;
    checkoutEnabled: boolean;
    testAutomationStandalone: boolean;
    jiraIssueCollectorUrl?: string;
    isUsageDataLessThan1Year?: boolean;
    sapSystemId?: string;
    qtEnabled: boolean;
    useAggregatedPerformanceTasks: boolean;
    dummyUserId?: number;
}
